import React, { Fragment, useContext, useState } from "react";
import { getCookie } from "../../modules/utils/cookie";

import styled, { css } from "styled-components";
import JsxParser from "react-jsx-parser";
import { PostApiPushInfo } from "../../modules/network/padoPost";
import { AppContext } from "../../components/AppProvider";
import { useEffect } from "react";
import SymbolPopup from "../../resources/images/icon/symbol_popup_careforme.png";
import "../../resources/css/Pretendard.css";

const Wrap = styled.section`
  box-sizing: border-box;
  padding: 20px 20px;
  width: 320px;
  height: 100vh;
  font-size: 14px;
  font-family: Pretendard;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 auto;
`;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;

  ${({ flex_direction }) =>
    css`
      flex-direction: ${flex_direction ? flex_direction : "column"};
    `}

  ${({ gap }) =>
    gap &&
    css`
      gap: ${gap};
    `}
`;
const Img = styled.img`
  width: 38px;
`;
const H1 = styled.h1`
  line-height: 24px;
  font-size: 18px;
  font-weight: 800;
  height: 24px;
`;
const P = styled.p`
  margin: 16px 0;
  white-space: pre-wrap;
  font-size: 14px;
  line-height: 24px;

  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `}
    ${({ max_height }) =>
    max_height &&
    css`
      max-height: ${max_height};
    `}
    ${({ font_size }) =>
    font_size &&
    css`
      font-size: ${font_size};
    `}
`;

const DL = styled.dl`
  margin: 20px 0;
  display: grid;
  grid-template-columns: 64px 1fr;
  font-size: 14px;
  height: 80px;
  line-height: 1;
  padding: 0 8px;
  row-gap: 5px;
  > dd, dt {
    display: flex;
    align-items: center;
  }
`;
const DT = styled.dt`
  color: #018ceb;
  display: flex;
  font-size: 14px;
  line-height: 19px;
  ${({ align_items }) =>
    align_items &&
    css`
      align-items: ${align_items};
    `}
`;
const DD = styled.dd`
  font-weight: 800;
  display: flex;
  font-size: 14px;
  ${({ align_items }) =>
    align_items &&
    css`
      align-items: ${align_items};
    `};
`;

const Ellipsis = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 12px;
  max-height: 36px;
  white-space: pre-wrap;
`;

const Button = styled.button`
  width: 100%;
  height: 40px;
  background-color: #018ceb;
  color: #fff;
  border-radius: 8px;
  font-family: Pretendard;
`;

const Line = styled.span`
  border-top: 1px solid #eaeaea;
`;

const Header = (props) => {
  return (
    <Div flex_direction={"row"} gap={"8px"}>
      <Img src={SymbolPopup}></Img>
      <H1>[케어포미]{props.title}</H1>
    </Div>
  );
};

const Main = (props) => {
  return (
    <Div>
      {props.top ? (
        <>
          <Top top={props.top} />
          <Line />
        </>
      ) : null}
      <Mid date={props.date} order={props.order} hospital={props.hospital} />
      <Line />
      {props.bot ? (
        <>
          <Bot bot={props.bot} />
        </>
      ) : null}
    </Div>
  );
};

const Top = (props) => {
  return <P>{`${props.top[0]}\n${props.top[1]}`}</P>;
};

const Mid = (props) => {
  return (
    <DL>
      <DT>일정</DT>
      <DD><Ellipsis>{props.date}</Ellipsis></DD>
      <DT>예약명</DT>
      <DD>
        <Ellipsis>{props.order}</Ellipsis>
      </DD>
      <DT>병원</DT>
      <DD><Ellipsis>{props.hospital}</Ellipsis></DD>
    </DL>
  );
};
const Bot = (props) => {
  return <P max_height={"48px"}>{props.bot}</P>;
};

const Footer = (props) => {
  return (
    <Div>
      <P color={"#018CEB"} font_size={"12px"}>
        문의 {props.help}
      </P>
    </Div>
  );
};
const Action = (props) => {
  return (
    <Div>
      <Div>
        {!!props.link ? (
          <Button
            onClick={() => {
              window.java.btnGotoUrl(`schedule/${props.link}`);
            }}
          >
            확인
          </Button>
        ) : (
          <Button onClick={() => window.java.btnClose()}>확인</Button>
        )}
      </Div>
    </Div>
  );
};

const PushMessage = (props) => {
  const onButton = (msg) => {
    alert(msg);
  };
  return (
    <Wrap>
      <div>
        <Header title={props.title} />
        <Main
          top={props.top}
          date={props.date}
          order={props.order}
          hospital={props.hospital}
          bot={props.bot}
        />
        <Footer help={props.help} />
      </div>
      <Action link={props.link} />
    </Wrap>
  );
};

export default (props) => {
  const { cfg } = useContext(AppContext);
  const [body, setBody] = useState("");

  const requestPushInfo = () => {
    PostApiPushInfo(cfg, props.match.params.msgId).then((res) => {
      if (res.resultMsg === "SUCC") {
        setBody(res.pushInfo.htmlBody ?? "");
      }
    });
  };

  useEffect(() => {
    requestPushInfo();
  }, []);

  // const jsxString = `
  // <PushMessage
  //         title={"#예약완료#"}
  //         top={["#조민경#", "#검사예약#이 #확정#되었습니다."]}
  //         button={"확인"}
  //         date={"#2022. 08.25(목) 오후 2:30#"}
  //         order={"#대장내시경#"}
  //         hospital={"#마음속내과(시흥)#"}
  //         bot={
  //           "#예약하신 검사와 관련하여 저녁 9시 이후 금식하세요. 기타 자세한 안내사항 및 검진을 위한 안내는#"
  //         }
  //         help={"#031-243-5348#"}
  //       />
  // `;
  return (
    <>
      {body ? (
        <>
          <JsxParser components={{ PushMessage }} jsx={body} />
        </>
      ) : null}

      {/* 가예약 완료 */}

      {/* <PushMessage
        title={"예정일 안내"}
        button={"확인"}
        date={"#2022. 08.25(목) 오후 2:30#"}
        order={"#예약명#"}
        hospital={"#병원명#"}
        bot={"#안내문구설정내용#"}
        help={"#문의번호#"}
      />
      <br /> */}

      {/* 가예약 리마인드 */}
      {/* <PushMessage
        title={"예정일 안내"}
        button={"확인"}
        date={"#2022. 08.25(목) 오후 2:30#"}
        order={"#예약명#"}
        hospital={"#병원명#"}
        bot={"#안내문구설정내용#"}
        help={"#문의번호#"}
      />
      <br /> */}

      {/* 
        확정예약완료
       */}
      {/* <PushMessage
        title={"예약 확정 안내"}
        top={["안녕하세요. #환자명#님", "아래와 같이 예약이 확정되었습니다."]}
        button={"확인"}
        date={"#2022. 08.25(목) 오후 2:30#"}
        order={"#예약명#"}
        hospital={"#병원명#"}
        bot={"#안내문구설정내용#"}
        help={"#문의번호#"}
      />
      <br /> */}

      {/* 확정예약 리마인드 */}
      {/* <PushMessage
        title={"예약일 안내"}
        top={["안녕하세요. #환자명#님", "예약일이 다가오고 있습니다."]}
        button={"확인"}
        date={"#2022. 08.25(목) 오후 2:30#"}
        order={"#예약명#"}
        hospital={"#병원명#"}
        bot={"#안내문구설정내용#"}
        help={"#문의번호#"}
      /> */}
      {/* <br /> */}

      {/* 
        확정예약안내
       */}
      {/* <PushMessage
        title={"예정일 취소 안내"}
        button={"확인"}
        date={"#2022. 08.25(목) 오후 2:30#"}
        order={"#예약명#"}
        hospital={"#병원명#"}
        help={"#문의번호#"}
      />
      <br /> */}
      {/* 
        확정예약안내
       */}
      {/* <PushMessage
        title={"예약 취소 안내"}
        button={"확인"}
        date={"#2022. 08.25(목) 오후 2:30#"}
        order={"#예약명#"}
        hospital={"#병원명#"}
        help={"#문의번호#"}
      /> */}

      {/* <span>msg={props.match.params.msgId} </span> */}
      {/* <JsxParser components={{ PushMessage }} jsx={jsxString} /> */}
    </>
  );
};

// const Body = (props) => {
//     return(
//         <Fragment>
//             <p>{props.msg}</p>
//             <p>{getCookie('userToken')}</p>

//             <Botton
//                 style={{
//                     float:"left"
//                 }}
//                 text={"닫기 테스트"}
//                 event={
//                     ()=>window.java.btnClose()
//                 }
//             />

//             <Botton
//                 style={{
//                     float:"right"
//                 }}
//                 text={"페이지 이동 테스트"}
//                 event={
//                     ()=>window.java.btnGotoUrl("/")
//                 }
//             />
//         </Fragment>
//     );
// }

// const Botton = (props) => {
//     const {style, text, event} = props;

//     return(
//         <input
//             type="button"
//             style={style}
//             value={text}
//             onClick={()=>event()}
//         />
//     );
// }

